import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class BootstrapService {
    private readonly loading = signal<boolean>(false);
    private readonly ready = signal<boolean>(false);

    isLoading(): boolean {
        return this.loading();
    }

    isReady(): boolean {
        return this.ready();
    }

    markLoading(): void {
        this.loading.set(true);
    }

    markReady(): void {
        this.loading.set(false);
        this.ready.set(true);
    }

    reset(): void {
        this.loading.set(false);
        this.ready.set(false);
    }
}
